<template>
  <div class="member-custom-tags-editor">
    <div class="tags-row">
      <el-tag v-for="tag in tags" :key="tag.id" :style="tagStyle(tag)" size="small" effect="plain" closable
        :disable-transitions="true" @close="handleRemove(tag)">
        {{ tag.tagName }}
      </el-tag>
      <span v-if="!tags.length" class="empty-text">无</span>
    </div>
    <div v-if="memberId" class="add-row">
      <el-select v-model="pendingValue" class="tag-select" filterable allow-create default-first-option clearable
        size="small" placeholder="选择或输入新标签（≤5字）" :loading="searchLoading" :remote-method="remoteSearch" remote
        @change="handleSelect">
        <el-option v-for="item in options" :key="item.id" :label="item.tagName" :value="item.id" />
      </el-select>
      <span v-if="maxCount > 0" class="limit-hint">{{ tags.length }}/{{ maxCount }}</span>
    </div>
  </div>
</template>

<script>
import {
  getMemberTagLimit,
  searchMemberTags,
  bindMemberTag,
  unbindMemberTag
} from '@/api/memberTag'

const SOURCE_STORE_PC = 2

export default {
  name: 'MemberCustomTagsEditor',
  props: {
    memberId: { type: String, default: '' },
    value: { type: Array, default: () => [] }
  },
  data() {
    return {
      tags: [],
      options: [],
      pendingValue: '',
      searchLoading: false,
      maxCount: 5
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.tags = Array.isArray(val) ? [...val] : []
      }
    }
  },
  created() {
    getMemberTagLimit().then(res => {
      const data = res.data || {}
      this.maxCount = Number(data.maxCount) > 0 ? Number(data.maxCount) : 5
    }).catch(() => { })
    this.remoteSearch('')
  },
  methods: {
    tagStyle(tag) {
      const color = (tag && tag.color) || '#409EFF'
      return { color, borderColor: color, backgroundColor: color + '1A' }
    },
    remoteSearch(keyword) {
      this.searchLoading = true
      searchMemberTags({ keyword: keyword || '', pageSize: 30 }).then(res => {
        this.options = Array.isArray(res.data) ? res.data : []
        this.searchLoading = false
      }).catch(() => {
        this.searchLoading = false
      })
    },
    resetAddState() {
      this.pendingValue = ''
    },
    handleSelect(val) {
      if (!val || !this.memberId) return
      const existing = this.options.find(o => o.id === val)
      if (existing) {
        this.addTag({ tagId: existing.id })
        return
      }
      const name = String(val).trim()
      if (!name) {
        this.resetAddState()
        return
      }
      if (name.length > 5) {
        this.$message.warning('标签名不能超过 5 个字')
        this.resetAddState()
        return
      }
      this.addTag({ tagName: name, color: '#409EFF' })
    },
    addTag(payload) {
      if (this.maxCount > 0 && this.tags.length >= this.maxCount) {
        this.$message.warning(`最多可添加 ${this.maxCount} 个标签`)
        this.resetAddState()
        return
      }
      bindMemberTag(this.memberId, { ...payload, source: SOURCE_STORE_PC }).then(res => {
        const tag = res.data
        if (tag && !this.tags.some(t => t.id === tag.id)) {
          this.tags.push(tag)
          this.$emit('input', this.tags)
        }
        this.resetAddState()
        this.remoteSearch('')
      }).catch(() => {
        this.resetAddState()
      })
    },
    handleRemove(tag) {
      if (!tag || !this.memberId) return
      unbindMemberTag(this.memberId, tag.id).then(() => {
        this.tags = this.tags.filter(t => t.id !== tag.id)
        this.$emit('input', this.tags)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.member-custom-tags-editor {
  width: 100%;
}

.tags-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  min-height: 28px;
}

.empty-text {
  color: #909399;
  font-size: 13px;
}

.add-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.tag-select {
  width: 100%;
}

.limit-hint {
  color: #909399;
  font-size: 12px;
  flex-shrink: 0;
}
</style>
